import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-currency-input',
    templateUrl: './currency-input.component.html',
    styleUrls: ['./currency-input.component.scss'],
    standalone: false
})
export class CurrencyInputComponent implements OnInit {
  @Input() data: string;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() disabledFlag: boolean;
  @Input() showError: boolean = false;
  @Input() required: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  editMode: boolean = false;
  tempValue: string = "";

  constructor() {}

  ngOnInit() {
    if(!this.data) {
      this.data = '0';
    }
  }

  changeToEdit(event) {
    if( !this.disabledFlag) {
      this.editMode = true;
    }
  }

  onFocusOut() {
    this.showError = false;
    this.editMode = false;
    this.focusOut.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.editMode = false;
    this.data = this.tempValue;
  }

}
